/**
 * Per-FI browser tab branding (NPSD-2319): fi_branding.app_favicon_url and
 * fi_branding.app_tab_title, shared with the receiving app. Empty (or missing)
 * values keep the defaults from public/index.html.
 */
let defaults = null;

const iconLink = () => document.querySelector("link[rel='icon']");

const captureDefaults = () => {
  if (!defaults) {
    defaults = {
      title: document.title,
      icon: iconLink()?.getAttribute("href") ?? null,
    };
  }
  return defaults;
};

// Only absolute http(s) URLs; anything else falls back to the default icon.
const safeUrl = (value) => {
  if (typeof value !== "string" || !value.trim()) return null;
  try {
    const url = new URL(value.trim());
    return url.protocol === "https:" || url.protocol === "http:" ? url.href : null;
  } catch (e) {
    return null;
  }
};

export const applyTabBranding = ({ faviconUrl, title } = {}) => {
  const d = captureDefaults();
  const t = typeof title === "string" ? title.trim() : "";
  document.title = t || d.title;

  const href = safeUrl(faviconUrl) ?? d.icon;
  const link = iconLink();
  if (link && href) {
    link.setAttribute("href", href);
  }
};
